import { Component, OnInit } from '@angular/core';
import { AppPermission } from '@app/shared/services/apps/apps.service';

@Component({
  standalone: false,
  selector: 'sbnb-rue-ba-rue',
  styles: [
    `
      p {
        margin-top: 0.25rem;
      }
    `,
  ],
  templateUrl: './rue-ba-rue.component.html',
})
export class RueBaRueComponent implements OnInit {
  public AppPermission = AppPermission;
  constructor() {}

  ngOnInit(): void {}
}
